import { Component } from "@angular/core";
import { NavController, NavParams, Platform, PopoverController, ViewController } from "ionic-angular";
import { DownloadFormat} from "../../models/interfaces/download-format";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ExportData} from "../../services/export-data";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
    selector: "page-member_popover",
    templateUrl: "member_popover.html",
  })
  export class MemberPopover{

  public aaa: String;
  private test: [object];
  private styleName: string ="";
  private data: [object];
  private downloadFormat: any = DownloadFormat;
  private selectedFormat: DownloadFormat ;

  constructor(private configService: ConfigService,public viewCtrl: ViewController, public navParams: NavParams/*, public fakeData: FakeData*/,
    public exportData: ExportData,  private db: DbserviceProvider) {
    //this.data = this.fakeData.getFakeData();
    this.styleName=this.configService.getConfig("STYLENAME");
    this.selectedFormat = DownloadFormat.TAB;
  }

  private export() {
     let data = this.navParams.get("data");

     this.db.dbCol({
      "action": "select", "mapObject": "pledge", "sqlExtended": " where pledge.ps_id = 1 order by pledge.pl_date desc",
    }).subscribe((datatoexport) => {

      this.data =  datatoexport;
      //this.exportData.export2CSV(datatoexport, this.selectedFormat, 'export.csv');
      this.exportData.export2CSV(this.data, this.selectedFormat, 'export.csv');
    });

    // save(data);
    this.viewCtrl.dismiss();

     // this.exportData.export2CSV(this.data, this.selectedFormat, 'export.csv');
     // save(data);
     // this.viewCtrl.dismiss();

  }
}



// WEBPACK FOOTER //
// ./src/pages/member/member_popover.ts